export default __webpack_public_path__ + "media/images/main-adv/sponsors-e3c2d5f2f1551ab509bbf4398be2d668.svg";